// extracted by mini-css-extract-plugin
module.exports = {"left__sidebar":"Home_left__sidebar__FUh0H","left__sidebar__content":"Home_left__sidebar__content__2JO_A","active":"Home_active__1RSFT","Content":"Home_Content__2tQCC"};